// dependencies
import React, { useState } from "react";

// api
import request from "../../Api/request";

// components
import Button from "Components/Button";
import TextInput from "Components/Inputs/Text";
import PageSpinner from "../../Components/Spinner/PageSpinner";

// css
import css from "./Me.styl";

const Me = () => {
	const [displayName, setName] = useState({ value: "", dirty: false });
	const [loading, setLoading] = useState(true);

	const nameUpdate = (newName) => {
		setName({ value: newName, dirty: true });
	};

	// need to update this call to be env specific before we use it
	const save = () => {
		setLoading(true);
		request({
			url: "/me",
			method: "PUT",
			data: {
				displayName: displayName.dirty ? displayName.value : undefined,
			},
		})
			.then((response) => {
				setName({ ...displayName, dirty: false });
				setLoading(false);
			})
			.catch((err) => {
				alert(err);
			});
	};

	if (loading && !displayName.dirty) {
		request({ url: "/me", method: "GET" })
			.then((response) => {
				setName({ ...displayName, value: response.data.displayName });
				setLoading(false);
			})
			.catch((err) => {
				alert(err);
			});
	}
	if (loading) {
		return <PageSpinner />;
	}
	return (
		<div className={css.formWrapper}>
			<div className={css.form}>
				<div className={css.label}>Display Name</div>
				<TextInput onChange={nameUpdate} value={displayName.value} />
			</div>
			<div className={css.inputContainer}>
				{displayName.dirty ? <Button onClick={save}>Save</Button> : null}
			</div>
		</div>
	);
};

export default Me;
